import { DetectedFace } from "./ApiTypes";

export const BASE_PATH = "https://storages.work";

export const getOriginalThumbnailUrl = (userId: string, originalId: string) => {
  return `${BASE_PATH}/users/${userId}/originals/${originalId}/thumbnail.jpg`;
};

export const getSwapThumbnailUrl = (userId: string, swapId: string) => {
  return `${BASE_PATH}/users/${userId}/swaps/${swapId}/original_thumbnail.jpg`;
};

// カタログのタイル画像。パスは (userId, faceId, sceneId) から一意に決まるので、
// サーバーの応答を待たずに描画できる（顔を切り替えた瞬間に URL だけ差し替える）。
export const getSceneThumbnailUrl = (userId: string, faceId: string, sceneId: string) => {
  return `${BASE_PATH}/users/${userId}/faces/${faceId}/scene_thumbnails/${sceneId}/thumbnail.jpg`;
};

export const getFaceCroppedSrc = (face: DetectedFace) => {
  return face.croppedFace 
    ? `data:image/jpeg;base64,${face.croppedFace}` 
    : `${BASE_PATH}/users/${face.userId}/faces/${face.faceId}/cropped.jpg`;
};

export const getFaceMeshedSrc = (face: DetectedFace) => {
  return face.meshedFace 
    ? `data:image/jpeg;base64,${face.meshedFace}` 
    : `${BASE_PATH}/users/${face.userId}/faces/${face.faceId}/meshed.jpg`;
};

export const getDownloadUrl = (userId: string, swapId: string) => {
  return `${BASE_PATH}/users/${userId}/swaps/${swapId}.ts`;
}